/*
Copyright 2026 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

import type { UnauthVersionURI } from "@/components/controllers/auth/ValidateAccessToken";
import DeviceDetail from "@/components/controllers/devices/device_detail/DeviceDetail";
import { BreadcrumbNav, BreadcrumbVariant, validateSearchBreadcrumbs, type BreadcrumbItem } from "@/components/ui/BreadcrumbNav";
import { useTranslation } from "@/i18n/client_hook";
import { defaultNS } from "@/i18n/settings";
import { AuthStates, getAuthState } from "@/lib/auth/auth_state";
import { devicesSelectors, useFetchDevicesQuery } from "@/lib/datastore/slices/devices";
import { createFileRoute } from "@tanstack/react-router";
import React from "react";

//Unauthenticated version of this page
export const unauthenticatedRedirect:UnauthVersionURI = (location):string|undefined => {
  const path_parts = location.pathname.split("/");
  if (path_parts.length == 3 && path_parts[1] == "device") {
    return `/device/${path_parts[2]}/public?` + (new URLSearchParams(location.search)).toString()
  }
  
  return undefined;
}

export const Route = createFileRoute("/_authenticated/device/$fguid")({
  component: RouteComponent,
  validateSearch: validateSearchBreadcrumbs
});

function RouteComponent() {
    const {t} = useTranslation(defaultNS);
    const {fguid} = Route.useParams();
    const { bc } = Route.useSearch();
    const org_id = getAuthState(AuthStates.activeOrgID)!;
    const { device } = useFetchDevicesQuery({org_id: org_id}, {
        selectFromResult: ({data, ...other}) => ({
            ...other,
            device: data ? devicesSelectors.selectById(data, fguid) : undefined
        })
    });

    return <React.Fragment>
        {device !== undefined && <div className="flex flex-col grow p-6 pl-0 pr-0">
            <BreadcrumbNav
                breadcrumbs={bc ? bc : []}
                className="pl-8"
                variant={BreadcrumbVariant.simpleBackButton}
            />
            <DeviceDetail 
                device={device} 
                hideProject={bc && bc[0] && bc[0].link_path=="/projects"} />
        </div>}
    </React.Fragment>;
}